// В.2.e-1: Эксперимент #42 (liv_eksperiment_42, epic, 4/2/3).
// Посмертие: «вместо сброса возвращается на поле».
//
// Реализация: при появлении на поле вешаем встроенный keyword
// posthumous_contract через addPermanentKeyword (В.2.d-3). Он одноразовый —
// после первого срабатывания снимается (Эксперимент #42 при второй смерти
// уйдёт в сброс обычно, что соответствует «вместо сброса» — буквально один
// раз). Если юзер захочет многоразового — балансный шаг отдельно.
//
// Хук — onUnitSummoned (registerUnitSummonedExtraHandler). resurrectUnit
// не зовёт onUnitSummoned (по правилам), поэтому контракт не повешается
// повторно после воскрешения. Дополнительная защита через флаг
// posthumousContractUsed.

import { registerUnitSummonedExtraHandler } from '../deus/hooks.js';
import { applyPosthumousContract } from '../../keywords/posthumous_contract.js';
import { hasKeyword, KW } from '../../keywords.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_eksperiment_42';
const SOURCE_ID = 'liv_eksperiment_42_innate';
const LABEL = 'Эксперимент #42';

registerImplementedAbility(CARD_ID, 'deathrattle');

registerUnitSummonedExtraHandler((state, ownerIdx, card) => {
  if (!card || card.id !== CARD_ID) return;
  if (card.posthumousContractUsed) return;
  if (hasKeyword(card, KW.POSTHUMOUS_CONTRACT)) return;
  applyPosthumousContract(state, card, SOURCE_ID, LABEL);
});
